import { lazy, Suspense as ReactSuspense } from "react";
import LoadingScreen from "../components/LoadingScreen";

const Suspense: any = ReactSuspense;

const Loadable = (Component: any) => (props: any) => {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );
};

const RouteLazyLoader: any = {
  // DASHBOARD ROUTES
  DashboardDashboard: Loadable(
    lazy(() => import("../pages/Dashboard/Dashboard")),
  ),

  /**
   * INVENTORY
   */
  // purchase orders
  PurchaseOrders: Loadable(
    lazy(() => import("../pages/Inventory/PurchaseOrders/PurchaseOrders")),
  ),
  PurchaseOrderForm: Loadable(
    lazy(
      () =>
        import(
          "../pages/Inventory/PurchaseOrders/PurchaseOrdersForm/PurchaseOrderForm"
        ),
    ),
  ),
  PurchaseOrderDetails: Loadable(
    lazy(
      () =>
        import(
          "../pages/Inventory/PurchaseOrders/Details/PurchaseOrderDetails"
        ),
    ),
  ),

  //Inventory received
  InventoryReceived: Loadable(
    lazy(
      () => import("../pages/Inventory/InventoryReceived/InventoryReceived"),
    ),
  ),
  InventoryReceivedDetails: Loadable(
    lazy(
      () =>
        import(
          "../pages/Inventory/InventoryReceived/Details/InventoryReceivedDetails"
        ),
    ),
  ),
  EditInventoryReceived: Loadable(
    lazy(
      () =>
        import(
          "../pages/Inventory/InventoryReceived/InventoryReceivedForm/InventoryReceivedForm"
        ),
    ),
  ),

  //sales
  Sales: Loadable(lazy(() => import("../pages/Inventory/Sales/Sales"))),
  SaleForm: Loadable(
    lazy(() => import("../pages/Inventory/Sales/NewSale/NewSaleForm")),
  ),
  CheckoutSale: Loadable(
    lazy(() => import("../pages/Inventory/Sales/NewSale/CheckoutSale")),
  ),
  SaleSuccessful: Loadable(
    lazy(() => import("../pages/Inventory/Sales/NewSale/SaleSuccessful")),
  ),
  SaleDetails: Loadable(
    lazy(() => import("../pages/Inventory/Sales/SaleDetails/SaleDetails")),
  ),

  //credit management
  CreditManagement: Loadable(
    lazy(() => import("../pages/Inventory/CreditManagement/CreditManagement")),
  ),
  ExpensesManagement: Loadable(
    lazy(
      () => import("../pages/Inventory/ExpensesManagement/ExpensesManagement"),
    ),
  ),

  /**
   * Reports
   */
  //Credit management
  UnpaidInvoicesReport: Loadable(
    lazy(
      () =>
        import(
          "../pages/Reports/CreditManagement/UnpaidInvoicesReport/UnpaidInvoicesReport"
        ),
    ),
  ),
  CreditActivityReport: Loadable(
    lazy(
      () =>
        import(
          "../pages/Reports/CreditManagement/CreditActivityReport/CreditActivityReport"
        ),
    ),
  ),
  PaymentTrendsReport: Loadable(
    lazy(
      () =>
        import(
          "../pages/Reports/CreditManagement/PaymentTrendsReport/PaymentTrendsReport"
        ),
    ),
  ),
  CreditManagementVisualizationReport: Loadable(
    lazy(
      () =>
        import("../pages/Reports/CreditManagement/Visualization/Visualization"),
    ),
  ),

  //Expenses
  ExpensesRegisterReport: Loadable(
    lazy(
      () =>
        import(
          "../pages/Reports/ExpensesReports/ExpensesRegisterReport/ExpensesRegisterReport"
        ),
    ),
  ),
  ExpensesCategorySummaryReport: Loadable(
    lazy(
      () =>
        import(
          "../pages/Reports/ExpensesReports/CategorySummaryReport/CategorySummaryReport"
        ),
    ),
  ),
  ExpensesCategoryCashAccountReport: Loadable(
    lazy(
      () =>
        import(
          "../pages/Reports/ExpensesReports/CashAccountSummaryReport/CashAccountSummaryReport"
        ),
    ),
  ),
  ExpenseVisualizationReport: Loadable(
    lazy(
      () =>
        import("../pages/Reports/ExpensesReports/Visualization/Visualization"),
    ),
  ),

  /**
   * CONFIGURATIONS
   */
  // purchase orders
  Items: Loadable(lazy(() => import("../pages/Configuration/Items/Items"))),
  ItemDetails: Loadable(
    lazy(() => import("../pages/Configuration/Items/Details/ItemDetails")),
  ),
  ItemCategories: Loadable(
    lazy(() => import("../pages/Configuration/ItemCategories/ItemCategories")),
  ),
  Suppliers: Loadable(
    lazy(() => import("../pages/Configuration/Suppliers/Suppliers")),
  ),
  Customers: Loadable(
    lazy(() => import("../pages/Configuration/Customers/Customers")),
  ),
  CustomerDetails: Loadable(
    lazy(
      () => import("../pages/Configuration/Customers/Details/CustomerDetails"),
    ),
  ),
  Branches: Loadable(
    lazy(() => import("../pages/Configuration/Branches/Branches")),
  ),
  Staff: Loadable(lazy(() => import("../pages/Configuration/Staff/Staff"))),
  PaymentAccounts: Loadable(
    lazy(
      () => import("../pages/Configuration/PaymentAccounts/PaymentAccounts"),
    ),
  ),
  ExpensesCategories: Loadable(
    lazy(
      () =>
        import("../pages/Configuration/ExpensesCategories/ExpensesCategories"),
    ),
  ),

  /**
   * ADMIN
   */
  AdminDashboard: Loadable(
    lazy(() => import("../pages/ZimbaAdmin/Dashboard/Dashboard")),
  ),
  Businesses: Loadable(
    lazy(() => import("../pages/ZimbaAdmin/Businesses/Businesses")),
  ),
  BusinessAdmins: Loadable(
    lazy(() => import("../pages/ZimbaAdmin/BusinessAdmins/BusinessAdmins")),
  ),
};

export default RouteLazyLoader;
